import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Box,
    Grid,
    Button,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { Link } from 'react-router-dom';

const Assets = () => {
    return (
        <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
                    Assets
                </Typography>
            </Box>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%', boxShadow: 3, transition: 'transform 0.2s', '&:hover': { transform: 'translateY(-4px)' } }}>
                        <CardContent sx={{ p: 4, textAlign: 'center' }}>
                            <SearchIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
                            <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 500 }}>
                                Asset Lookup
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                                View asset details and update images
                            </Typography>
                            <Button
                                component={Link}
                                to="/assets/lookup"
                                variant="contained"
                                color="primary"
                                size="large"
                                startIcon={<SearchIcon />}
                                sx={{ minWidth: 200 }}
                            >
                                Lookup Asset
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%', boxShadow: 3, transition: 'transform 0.2s', '&:hover': { transform: 'translateY(-4px)' } }}>
                        <CardContent sx={{ p: 4, textAlign: 'center' }}>
                            <AddIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
                            <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 500 }}>
                                Add New Asset
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                                Create a new asset in DB
                            </Typography>
                            <Button
                                component={Link}
                                to="/assets/add"
                                variant="contained"
                                color="success"
                                size="large"
                                startIcon={<AddIcon />}
                                sx={{ minWidth: 200 }}
                            >
                                Add Asset
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Assets;